import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MailingMessageTypeEnum } from '@app/mailing';

@Injectable({
  providedIn: 'root'
})
export class MailingService {
  constructor(private http: HttpClient) { }

  sendUnsubscribeRequest(customerId: string, messageType: MailingMessageTypeEnum): Observable<any> {
    return this.http.post(`/api/account/mailing/unsubscribe`, { customerId, messageType });
  }

}
